// context/SocketContext.js
import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import { io } from "socket.io-client";
import { useAuth } from "./AuthContext"; // Ensure it provides clientData with client_id

const SocketContext = createContext();

export const useSocket = () => useContext(SocketContext);

export const SocketProvider = ({ children }) => {
  const { clientData } = useAuth();
  const socketRef = useRef(null);
  const [connectedDevices, setConnectedDevices] = useState([]);
  const [realtimeData, setRealtimeData] = useState({});
  const [deviceStatusUpdate, setDeviceStatusUpdate] = useState({});

  useEffect(() => {
    if (!clientData?.client_id) return;

    socketRef.current = io("https://api.mashfarm.online", {
         transports: ["websocket"],   // you can include polling as fallback
  secure: true,                // force HTTPS/WSS
  rejectUnauthorized: false    // if you’re using self-signed cert during testing
    });

    socketRef.current.on("connect", () => {
      console.log("🔌 Connected to server");
      socketRef.current.emit("authenticateUser", clientData.client_id);
    });

    socketRef.current.on("authenticated", ({ status, devices }) => {
      console.log("✅ Authenticated", devices);
      setConnectedDevices(devices);
    });


    socketRef.current.on("realtimeData", (data) => {
  console.log("📡 realtimeData received:", data);
  const { deviceId, payload } = data;
  setRealtimeData((prev) => ({ ...prev, [deviceId]: payload }));
});
socketRef.current.on("deviceStatusUpdate", ({ deviceId, status }) => {
  console.log(`🔄 Device ${deviceId} is now ${status}`);
  setDeviceStatusUpdate((prev) => ({
    ...prev,
    [deviceId]: { status }
  }));
});

    socketRef.current.on("disconnect", () => {
      console.log("❌ Socket disconnected");
    });

    return () => {
      socketRef.current?.disconnect();
    };
  }, [clientData?.client_id]);

  // Function to send command to a device
  const sendCommand = (deviceId, type, value) => {
    if (!socketRef.current) return;
    socketRef.current.emit("sendCommand", { deviceId, type, value });
  };
  const refreshCommand = (deviceId,mac) => {
    if (!socketRef.current) return;
    console.log("Sending Refresh")
    socketRef.current.emit("refresh", { deviceId,mac});
  };

  return (
    <SocketContext.Provider
      value={{
        socket: socketRef.current,
        connectedDevices,
        realtimeData,
        sendCommand,
        deviceStatusUpdate,
        refreshCommand,
      }}
    >
      {children}
    </SocketContext.Provider>
  );
};
